// extracted by mini-css-extract-plugin
module.exports = {"detail_rank_block_wrapper":"DetailRankBlock_detail_rank_block_wrapper__3REoS"};